const BATTLEFIELD_URL = `${import.meta.env.BASE_URL}battlefield.png`;

export const MAIN_MENU_BACKDROP_CSS = `
.main-menu__bg {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
  background: #02060d;
}

.main-menu__bg-image {
  position: absolute;
  inset: -3%;
  background: url("${BATTLEFIELD_URL}") center center / cover no-repeat;
  filter: contrast(1.08) saturate(1.18) brightness(1.06);
  transform: scale(1.035);
  animation: mm-bg-drift 18s ease-in-out infinite;
}

.main-menu__bg-bloom {
  position: absolute;
  inset: 0;
  mix-blend-mode: screen;
  background:
    radial-gradient(ellipse 22% 38% at 12% 32%, rgba(110, 200, 255, 0.35) 0%, transparent 60%),
    radial-gradient(ellipse 22% 38% at 88% 26%, rgba(255, 100, 100, 0.32) 0%, transparent 60%);
  animation: mm-bloom-pulse 5s ease-in-out infinite;
}

.main-menu__bg-center-dim {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 42% 55% at 50% 56%,
      rgba(2, 6, 13, 0.82) 0%,
      rgba(2, 6, 13, 0.50) 38%,
      rgba(2, 6, 13, 0) 78%);
}

.main-menu__bg-rim {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 22% 60% at 0% 50%, rgba(30, 167, 255, 0.22) 0%, transparent 70%),
    radial-gradient(ellipse 22% 60% at 100% 50%, rgba(255, 42, 42, 0.22) 0%, transparent 70%);
  animation: mm-rim-pulse 4.2s ease-in-out infinite;
}

.main-menu__bg-vignette {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 110% 80% at 50% 50%, transparent 50%, rgba(0,0,0,0.55) 100%),
    linear-gradient(180deg, rgba(0,0,0,0.4) 0%, transparent 18%, transparent 82%, rgba(0,0,0,0.55) 100%);
}

.main-menu__bg-scan {
  position: absolute;
  inset: 0;
  background: repeating-linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0,
    rgba(0, 0, 0, 0) 2px,
    rgba(0, 0, 0, 0.10) 3px,
    rgba(0, 0, 0, 0) 4px
  );
  opacity: 0.35;
  mix-blend-mode: multiply;
}

.main-menu__bg-grain {
  position: absolute;
  inset: 0;
  opacity: 0.09;
  mix-blend-mode: overlay;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='240' height='240'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 0.5 0 0 0 0 0.5 0 0 0 0 0.5 0 0 0 1 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>");
  animation: mm-grain-shift 1.6s steps(6) infinite;
}

.main-menu__spark {
  position: absolute;
  width: 2px;
  height: 2px;
  border-radius: 50%;
}

.main-menu__spark--blue {
  background: var(--mm-blue-pure);
  box-shadow: 0 0 10px 2px var(--mm-blue-glow);
}

.main-menu__spark--red {
  background: var(--mm-red-pure);
  box-shadow: 0 0 10px 2px var(--mm-red-glow);
}

@keyframes mm-bg-drift {
  0%, 100% { transform: translate3d(0, 0, 0) scale(1.035); }
  50% { transform: translate3d(-10px, 6px, 0) scale(1.045); }
}

@keyframes mm-bloom-pulse {
  0%, 100% { opacity: 0.75; }
  50% { opacity: 1; }
}

@keyframes mm-rim-pulse {
  0%, 100% { opacity: 0.65; }
  50% { opacity: 1; }
}

@keyframes mm-grain-shift {
  0% { transform: translate(0, 0); }
  16% { transform: translate(-3px, 1px); }
  32% { transform: translate(2px, -2px); }
  48% { transform: translate(-1px, 2px); }
  64% { transform: translate(3px, 1px); }
  80% { transform: translate(-2px, -1px); }
  100% { transform: translate(0, 0); }
}

@keyframes mm-float-a {
  0%, 100% { transform: translate(0, 0); opacity: 0.7; }
  50% { transform: translate(22px, -32px); opacity: 1; }
}

@keyframes mm-float-b {
  0%, 100% { transform: translate(0, 0); opacity: 0.5; }
  50% { transform: translate(-18px, -28px); opacity: 1; }
}
`;

export function appendMainMenuBackdrop(root: HTMLElement): void {
  const bg = document.createElement('div');
  bg.className = 'main-menu__bg';
  bg.setAttribute('aria-hidden', 'true');
  bg.innerHTML = `
    <div class="main-menu__bg-image"></div>
    <div class="main-menu__bg-bloom"></div>
    <div class="main-menu__bg-center-dim"></div>
    <div class="main-menu__bg-rim"></div>
    <div class="main-menu__bg-vignette"></div>
    <div class="main-menu__bg-scan"></div>
    <div class="main-menu__bg-grain"></div>
    <div class="main-menu__spark main-menu__spark--blue" style="top: 22%; left: 12%; animation: mm-float-a 7s ease-in-out infinite;"></div>
    <div class="main-menu__spark main-menu__spark--blue" style="top: 65%; left: 8%; animation: mm-float-b 9s ease-in-out infinite;"></div>
    <div class="main-menu__spark main-menu__spark--blue" style="top: 80%; left: 22%; animation: mm-float-a 11s 1s ease-in-out infinite;"></div>
    <div class="main-menu__spark main-menu__spark--red" style="top: 30%; right: 12%; animation: mm-float-b 8s ease-in-out infinite;"></div>
    <div class="main-menu__spark main-menu__spark--red" style="top: 70%; right: 9%; animation: mm-float-a 10s 0.5s ease-in-out infinite;"></div>
    <div class="main-menu__spark main-menu__spark--red" style="top: 50%; right: 22%; animation: mm-float-b 12s 1.5s ease-in-out infinite;"></div>
  `;
  root.appendChild(bg);
}
